import React from 'react';
import Input from './Input';
import Form from '../../Components/Generic/Form';
import ArrayInput from '../../Components/Generic/ArrayInput';
import { FloppyFill as FloppyIcon, ChevronLeft } from './Icons';

const getInputComponent = (toValue, inputProps, labelOverride, required, toObject) => ({value, onSubmit, onChange, isNew, onCancel, formContainerRef}) => { 
    const formRef = React.useRef();
    return (
        <Form ref={formRef} onSubmit={onSubmit} isNew={isNew} forceCallback={required && isNew}>
            <Input
                required
                value={(typeof toValue === "function"?  toValue(value) : value) || ""}
                onChange={typeof toObject === "function"? (d) =>  onChange(toObject(d, value)) : onChange}
                addOn={{
                    children: (
                        <div className="btn-group">
                            {!isNew && (
                                <button 
                                    type="button"
                                    onClick={onCancel}
                                    className="btn btn-transparent cancel-button pe-3"
                                >
                                    <ChevronLeft className="me-2"/> Cancel
                                </button>
                            )}
                            <button 
                                type="button"
                                onClick={() => {
                                    if(formRef.current && formRef.current.reportValidity()) {
                                        onSubmit();
                                    }
                                }}
                                className="btn btn-primary submit-button rounded-pill"
                            >
                                <FloppyIcon className="me-2"/> {labelOverride(isNew? "Add" : "Save")}
                            </button>
                        </div>
                    )
                }}
                {...(typeof inputProps === "function"? inputProps({value, onSubmit, onChange, isNew, onCancel, formContainerRef}) 
                    :inputProps? inputProps : {})}
                
            />
        </Form>
    )
};

const getDisplayComponent = (toValue, toDisplay) => ({value}) => {
    return <span>{
        typeof toDisplay === "function"? toDisplay(value)
        : typeof toValue === "function"? toValue(value)
        : value.length? value : ""
    }</span>;
};

export default function StringArrayInput({toValue, toObject, toDisplay, toKey, inputProps, labelOverride, required, ...props}) {
    const InputComponent = React.useMemo(() =>  getInputComponent(toValue, inputProps, (labelOverride || (a => a)), required, toObject),
        [toValue, inputProps, labelOverride, required, toObject]);

    const DisplayComponent = React.useMemo(() => getDisplayComponent(toValue, toDisplay), [toValue, toDisplay]);
    return (
        <ArrayInput
            InputComponent={InputComponent}
            DisplayComponent={DisplayComponent}
            newValue=""
            keyFunction={toKey}
            noActionComponents
            {...props}
        />
    );
}